"use strict";
/**
 * params.js
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashes = void 0;
exports.hashes = {
    // maxInput: 2^maxInput - 1 octets
    'SHA-256': { nodeName: 'sha256', hashSize: 32, maxInput: 61 },
    'SHA-384': { nodeName: 'sha384', hashSize: 48, maxInput: 125 },
    'SHA-512': { nodeName: 'sha512', hashSize: 64, maxInput: 125 },
    'SHA-1': { nodeName: 'sha1', hashSize: 20, maxInput: 61 },
};
//# sourceMappingURL=params.js.map